const translations = {
  'team.seo.title': 'Nuestro equipo directivo y profesores España',
  'team.seo.description': `TEFL Iberia es una escuela TEFL amigable y profesional en Barcelona y Sevilla. Obtén más información sobre nuestro equipo de gestión.`,
  'team.sec1.title': 'Nuestro equipo de TEFL Iberia',
  'team.sec1.description':
    'TEFL Iberia está formado por un equipo diverso y único que comparte algunas cosas clave en común: a todos nos encanta aprender, a todos nos apasiona Barcelona y a todos nos encanta trabajar en un ambiente positivo donde es posible el desarrollo personal. Conoce a las personas que hacen que TEFL en Barcelona suceda.',
  'team.sec2.publication': 'RECONOCIMIENTOS',
};

export default translations;
